import memoryStorage from './memory-storage';
import cookieStorage from './cookie-storage';
var prefix = '_f60';

function getWebStorageImpl(type) {
  var storage;

  try {
    storage = window[type === 'local' ? 'localStorage' : 'sessionStorage'];
  } catch (e) {
    // in certain scenarios accessing the window[storage] property will throw an access denied error
    return null;
  }

  return storage;
}

function set(key, value, storage) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var data;
  var _options$serialize = options.serialize,
      serialize = _options$serialize === void 0 ? true : _options$serialize;

  if (!storage) {
    return null;
  }

  if (typeof value === 'object' && serialize === true) {
    try {
      data = JSON.stringify(value);
    } catch (e) {
      throw new Error('@flowio/storage: cannot serialize value object');
    }
  } else {
    data = value;
  }

  var prefixedKey = "".concat(prefix, "_").concat(key);

  try {
    storage.setItem(prefixedKey, data, options);
  } catch (e) {// error can occur here is storage quota is reached on device.
  }

  return data;
}

function get(key, storage) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data;
  var _options$serialize2 = options.serialize,
      serialize = _options$serialize2 === void 0 ? true : _options$serialize2;
  var prefixedKey = "".concat(prefix, "_").concat(key);

  if (!storage) {
    return null;
  }

  data = storage.getItem(prefixedKey);

  if (data) {
    try {
      data = serialize ? JSON.parse(data) : data;
    } catch (e) {// it wasn't json
    }
  }

  return data;
}

function remove(key, storage) {
  var prefixedKey = "".concat(prefix, "_").concat(key);

  if (storage) {
    storage.removeItem(prefixedKey);
  }
}

export var session = {
  set: function setSessionStorage(key, value) {
    return set(key, value, getWebStorageImpl('session'));
  },
  get: function getSessionStorage(key) {
    return get(key, getWebStorageImpl('session'));
  },
  remove: function removeSessionStorage(key) {
    return remove(key, getWebStorageImpl('session'));
  }
};
export var local = {
  set: function setLocalStorage(key, value) {
    return set(key, value, getWebStorageImpl('local'));
  },
  get: function getLocalStorage(key) {
    return get(key, getWebStorageImpl('local'));
  },
  remove: function removeLocalStorage(key) {
    return remove(key, getWebStorageImpl('local'));
  }
};
export var memory = {
  set: function setMemoryStorage(key, value) {
    return set(key, value, memoryStorage, {
      serialize: false
    });
  },
  get: function getMemoryStorage(key) {
    return get(key, memoryStorage, {
      serialize: false
    });
  },
  remove: function removeMemoryStorage(key) {
    return remove(key, memoryStorage);
  }
};
export var cookie = {
  set: function setCookieStorage(key, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return set(key, value, cookieStorage, options);
  },
  get: function getCookieStorage(key) {
    return get(key, cookieStorage);
  },
  remove: function removeCookieStorage(key) {
    return remove(key, cookieStorage);
  }
};
export default {
  local: local,
  session: session,
  memory: memory,
  cookie: cookie
};
//# sourceMappingURL=index.js.map